export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10672.f3dc8772.jpg";